import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType, NavigationType } from 'react-router-dom';
import { APP_MAIN_SCROLL_ID } from '@utils/scrollToTop';

function resolveFocusTarget(): HTMLElement | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const main =
    document.getElementById(APP_MAIN_SCROLL_ID) ??
    document.querySelector<HTMLElement>('[role="main"]') ??
    document.querySelector<HTMLElement>('main');

  const scope: ParentNode = main ?? document;
  const heading = scope.querySelector<HTMLElement>('h1');

  return heading ?? main;
}

export function useFocusMainHeadingOnRouteChange(): void {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (navigationType !== NavigationType.Push) {
      return;
    }

    const target = resolveFocusTarget();
    if (!target) {
      return;
    }

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }

    target.focus({ preventScroll: true });
  }, [pathname, navigationType]);
}
